import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'distance'
})
export class DistancePipe implements PipeTransform {

  transform(value: any,decimalPlaces: number = 1): string {
    const d = parseFloat(value); 
    if(isNaN(d) || d<0) return '--';
    if (Object.is(d, -0)) return '0.0 Km';   
    return d.toFixed(decimalPlaces) + ' Km';             
  }

}
